const inicialState = {
  pcrFinalizada: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/pcr/pcr.state.js